export const GIOTTO_AI_HUB_DEFAULT_VIEWS = {
  global: "results",
  org: "credits",
};

export const GIOTTO_AI_HUB_VIEWS = {
  global: ["credits", "statistics", "purchases", "results"],
  org: ["credits", "results"],
};

export const getGiottoAiHubView = (search, mode) => {
  const availableViews = GIOTTO_AI_HUB_VIEWS[mode] || [];
  const params = new URLSearchParams(search);
  const requestedView = params.get("view");

  if (
    !requestedView &&
    availableViews.includes("results") &&
    (params.has("types") || params.has("org"))
  ) {
    return "results";
  }

  return availableViews.includes(requestedView)
    ? requestedView
    : GIOTTO_AI_HUB_DEFAULT_VIEWS[mode] || "credits";
};

export const buildGiottoAiHubSearch = (search, view, mode) => {
  const params = new URLSearchParams(search);
  params.delete("view");

  const searchWithoutView = params.toString();
  const inferredView = getGiottoAiHubView(
    searchWithoutView ? `?${searchWithoutView}` : "",
    mode
  );

  if (inferredView !== view) {
    params.set("view", view);
  }

  const nextSearch = params.toString();
  return nextSearch ? `?${nextSearch}` : "";
};
